import { FC } from 'react';
import { cn } from '@fe-learner-common';
import { formatDate } from '@fe-learner-common/utils/date';

type CalendarIconProps = {
  className?: string;
  date: number;
  size: 'md';
  disabled?: boolean;
};

const sizeMap = {
  md: 'w-[40px] h-[40px] min-w-[40px] min-h-[40px]',
};

export const CalendarIcon: FC<CalendarIconProps> = ({
  className,
  date,
  size,
  disabled,
  ...rest
}) => {
  return (
    <div
      className={cn(
        'flex flex-col rounded-lg bg-neutral-0 text-center shadow-50',
        className,
        sizeMap[size],
      )}
      {...rest}
    >
      <p
        className={cn(
          'text rounded-t-lg bg-negative-500 text-[.5rem] font-bold uppercase leading-[0.875rem] tracking-[0.5px] text-neutral-0',
          {
            'bg-neutral-500': disabled,
          },
        )}
      >
        {formatDate(date, 'MMM')?.replace('.', '')}
      </p>
      <p className="flex flex-1 items-center justify-center text-label-lg">
        {formatDate(date, 'd')}
      </p>
    </div>
  );
};
